// extracted by mini-css-extract-plugin
export default {"seriesName":"delete-series-modal_seriesName__eVJ9F"};